import { useMutation, useQuery } from '@tanstack/react-query';
import { publicApi } from '@/services/api';

export interface PublicIndustry {
    ulid: string;
    name: string;
}

export function usePublicIndustries() {
    return useQuery({
        queryKey: ['public', 'industries'],
        queryFn: async () => {
            const { data } = await publicApi.get<{ success: boolean; data: PublicIndustry[] }>('/industries');
            return data.data;
        },
        staleTime: 5 * 60 * 1000,
    });
}

export interface DemoRequestPayload {
    name: string;
    email: string;
    phone: string;
    application?: string;
    industry?: string;
    address?: string;
    city?: string;
    zip_code?: string;
    message?: string;
}

export function useSubmitDemoRequest() {
    return useMutation({
        mutationFn: async (payload: DemoRequestPayload) => {
            const { data } = await publicApi.post<{ success: boolean; message: string }>('/demo-requests', payload);
            return data;
        },
    });
}
